import "./src/styles/tailwind.css";
import "leaflet/dist/leaflet.css";

import { initialiseAnalytics, trackPageView } from "./src/utils/analytics";

export const onClientEntry = () => {
  initialiseAnalytics();
};

export const onRouteUpdate = ({ location }) => {
  // Let React Helmet update document.title before the page_view is queued.
  window.setTimeout(() => trackPageView(location), 50);
};
